import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import DashboardPage from '../pages/DashboardPage';
import AgentConfigPage from '../pages/AgentConfigPage';
import SettingsPage from '../pages/SettingsPage';
import HistoryPage from '../pages/HistoryPage';
import DocumentsPage from '../pages/DocumentsPage';
import DemandsPage from '../pages/DemandsPage';
import AnnouncementsPage from '../pages/AnnouncementsPage';
import AdminProducts from '../pages/AdminProducts';
import AdminProductForm from '../pages/AdminProductForm';
import AdminSolutions from '../pages/AdminSolutions';
import AdminSolutionForm from '../pages/AdminSolutionForm';
import AdminKnowledge from '../../pages/AdminKnowledge';
import UsersPage from '../pages/UsersPage';
import PointsPage from '../pages/PointsPage';
import EngineerVerificationsPage from '../pages/EngineerVerificationsPage';
import SuppliersPage from '../pages/SuppliersPage';
import BackupPage from '../pages/BackupPage';
import BannersPage from '../pages/BannersPage';
import LogsPage from '../pages/LogsPage';
import ServiceMonitorPage from '../pages/ServiceMonitorPage';
import CdnSettingsPage from '../pages/CdnSettingsPage';

// 路由守卫组件
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

// 用于强制组件在路由变化时重新挂载
const RouteProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return React.cloneElement(children, { key: location.pathname });
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <RouteProvider>
            <DashboardPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/agent-config" element={
        <ProtectedRoute>
          <RouteProvider>
            <AgentConfigPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <RouteProvider>
            <SettingsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/backup" element={
        <ProtectedRoute>
          <RouteProvider>
            <BackupPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/history" element={
        <ProtectedRoute>
          <RouteProvider>
            <HistoryPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/documents" element={
        <ProtectedRoute>
          <RouteProvider>
            <DocumentsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/demands" element={
        <ProtectedRoute>
          <RouteProvider>
            <DemandsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/announcements" element={
        <ProtectedRoute>
          <RouteProvider>
            <AnnouncementsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/products" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminProducts />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/products/new" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminProductForm />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/products/edit/:id" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminProductForm />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/solutions" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminSolutions />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/solutions/new" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminSolutionForm />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/solutions/edit/:id" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminSolutionForm />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/knowledge" element={
        <ProtectedRoute>
          <RouteProvider>
            <AdminKnowledge />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/users" element={
        <ProtectedRoute>
          <RouteProvider>
            <UsersPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/points" element={
        <ProtectedRoute>
          <RouteProvider>
            <PointsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/engineer-verifications" element={
        <ProtectedRoute>
          <RouteProvider>
            <EngineerVerificationsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/suppliers" element={
        <ProtectedRoute>
          <RouteProvider>
            <SuppliersPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/banners" element={
        <ProtectedRoute>
          <RouteProvider>
            <BannersPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/logs" element={
        <ProtectedRoute>
          <RouteProvider>
            <LogsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/service" element={
        <ProtectedRoute>
          <RouteProvider>
            <ServiceMonitorPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
      <Route path="/cdn" element={
        <ProtectedRoute>
          <RouteProvider>
            <CdnSettingsPage />
          </RouteProvider>
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default AdminRoutes;